export default {
  issueDetail: {
    title: 'Issue Details',
    qrCode: 'QR Code',
    qrCodePlaceholder: 'Enter QR code',
    productInfo: 'Product Info',
    productInfoPlaceholder: 'Search by keyword',
    relatedInfo: 'Related Info',
    relatedInfoPlaceholder: 'Search by keyword',
    memberInfo: 'Member Info',
    memberInfoPlaceholder: 'Member Info',
    issueTime: 'Issue Time',
    country: 'Country',
    issuePoints: 'Points Issued',
    spec: 'Spec',
    memberId: 'Member Info',
    direction: 'Direction',
    directionAdd: 'Increase',
    directionSubtract: 'Decrease',
    directionFreeze: 'Freeze',
    directionUnfreeze: 'Unfreeze',
    points: 'Points',
    beforePoints: 'Before',
    afterPoints: 'After',
    sourceType: 'Source Type',
    sourceTypeScan: 'Scan',
    sourceTypeActivity: 'Activity',
    sourceTypeManual: 'Manual',
    sourceTypeMall: 'Mall',
    sourceTypeRedPacket: 'Red Packet',
    sourceName: 'Source Name',
    remark: 'Remark',
    timeRequired: 'Please select issue time',
  },
  issueStats: {
    title: 'Issue Statistics',
    date: 'Date',
    totalIssued: 'Total Issued',
    totalConsumed: 'Total Consumed',
    chartTitle: 'Points Issued (Last 7 Days)',
    rankTitle: 'Product Issue Ranking',
    rankNo: 'Rank',
    productDetail: 'Product Detail',
    totalPoints: 'Total Points',
  },
  config: {
    title: 'Config / Points Rules',
    language: 'Language',
    addLang: 'Add Language',
    deleteLang: 'Delete Language',
    deleteLangConfirm: 'Confirm to delete current language config?',
    ruleTitle: 'Title',
    content: 'Content',
    addLangModalTitle: 'Add Language',
    languagePlaceholder: 'Select language',
  },
};
